import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=feb25cc6&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=feb25cc6&prod&lang=less&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=feb25cc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb25cc6",
  null
  
)

export default component.exports